<template>
    <div :class="'bizcomp-service-subscript bizcomp ' + className">
        <div>
            <div class="service-subscript-head">
                <div class="service-subscript-head-bar"></div>
                <div class="service-subscript-head-text">接收渠道</div>
            </div>
            <div class="service-subscript-phone-email">
                <div class="service-subscript-phone-contain">
                    <div class="service-subscript-phone">
                        <div class="service-subscript-phone-title">手机号码</div>
                        <div class="service-subscript-phone-text">
                            {{ info.mobileno }}
                        </div>
                    </div>
                    <div
                        class="service-subscript-phone-edit cursor-pointer"
                        v-on:click="modifyMobile"
                    >
                        <img src="../../assets/img/edit-icon.png" alt="" />
                    </div>
                </div>
                <div class="service-subscript-phone-contain service-subscript-email-contain">
                    <div class="service-subscript-phone">
                        <div class="service-subscript-phone-title">电子邮箱</div>
                        <div class="service-subscript-phone-text">
                            {{ info.email }}
                        </div>
                    </div>
                    <div
                        class="service-subscript-phone-edit cursor-pointer"
                        v-on:click="modifyEmail"
                    >
                        <img src="../../assets/img/edit-icon.png" alt="" />
                    </div>
                </div>
            </div>
            <div class="service-subscript-head margin-l-40">
                <div class="service-subscript-head-bar"></div>
                <div class="service-subscript-head-text">账单类定制</div>
            </div>
            <div class="service-subscript-content">
                <el-row class="el-row-common">
                    <el-col class="font-weight-bold" :span="4">月度账单订阅</el-col>
                    <el-col :span="20">
                        <div class="sms-email-subscription">
                            <div>
                                短信订阅
                                <el-checkbox
                                    v-model="checkedObj[0].status"
                                    size="mini"
                                    text-color="red"
                                    v-on:change="handleCheck"
                                ></el-checkbox>
                            </div>
                            <div class="email-subscription">
                                邮箱订阅
                                <el-checkbox
                                    v-model="checkedObj[1].status"
                                    size="mini"
                                    text-color="red"
                                    v-on:change="handleCheck"
                                ></el-checkbox>
                            </div>
                        </div>
                    </el-col>
                </el-row>
                <el-row class="el-row-common background-f9f9f9">
                    <el-col class="font-weight-bold" :span="4">季度账单订阅</el-col>
                    <el-col :span="20">
                        <div class="sms-email-subscription">
                            <div>
                                短信订阅
                                <el-checkbox
                                    v-model="checkedObj[2].status"
                                    size="mini"
                                    text-color="red"
                                    v-on:change="handleCheck"
                                ></el-checkbox>
                            </div>
                            <div class="email-subscription">
                                邮箱订阅
                                <el-checkbox
                                    v-model="checkedObj[3].status"
                                    size="mini"
                                    text-color="red"
                                    v-on:change="handleCheck"
                                ></el-checkbox>
                            </div>
                        </div>
                    </el-col>
                </el-row>
                <el-row class="el-row-common">
                    <el-col class="font-weight-bold" :span="4">年度账单订阅</el-col>
                    <el-col :span="20">
                        <div class="sms-email-subscription">
                            <div>
                                短信订阅
                                <el-checkbox
                                    v-model="checkedObj[4].status"
                                    size="mini"
                                    text-color="red"
                                    v-on:change="handleCheck"
                                ></el-checkbox>
                            </div>
                            <div class="email-subscription">
                                邮箱订阅
                                <el-checkbox
                                    v-model="checkedObj[5].status"
                                    size="mini"
                                    text-color="red"
                                    v-on:change="handleCheck"
                                ></el-checkbox>
                            </div>
                            <div class="email-subscription">
                                纸质账单订阅
                                <el-checkbox
                                    v-model="checkedObj[6].status"
                                    size="mini"
                                    text-color="red"
                                    v-on:change="handleCheck"
                                ></el-checkbox>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div class="service-subscript-head margin-l-40">
                <div class="service-subscript-head-bar"></div>
                <div class="service-subscript-head-text">净值类定制</div>
            </div>
            <div class="service-subscript-content">
                <el-row class="el-row-common">
                    <el-col class="font-weight-bold" :span="4">每日净值</el-col>
                    <el-col :span="20">
                        <div>
                            短信订阅
                            <el-checkbox
                                v-model="checkedObj[7].status"
                                size="mini"
                                text-color="red"
                                v-on:change="handleCheck"
                            ></el-checkbox>
                        </div>
                    </el-col>
                </el-row>
                <el-row class="el-row-common background-f9f9f9">
                    <el-col class="font-weight-bold" :span="4">每周五净值</el-col>
                    <el-col :span="20">
                        <div>
                            短信订阅
                            <el-checkbox
                                v-model="checkedObj[8].status"
                                size="mini"
                                text-color="red"
                                v-on:change="handleCheck"
                            ></el-checkbox>
                        </div>
                    </el-col>
                </el-row>
                <el-row class="el-row-common">
                    <el-col class="font-weight-bold" :span="4">净值涨跌幅</el-col>
                    <el-col :span="20">
                        <div>
                            短信订阅
                            <el-checkbox
                                v-model="checkedObj[9].status"
                                size="mini"
                                text-color="red"
                                v-on:change="handleCheck"
                            ></el-checkbox>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div class="service-subscript-head margin-l-40">
                <div class="service-subscript-head-bar"></div>
                <div class="service-subscript-head-text">交易类定制</div>
            </div>
            <div class="service-subscript-content">
                <el-row class="el-row-common">
                    <el-col class="font-weight-bold" :span="4">交易确认</el-col>
                    <el-col :span="20">
                        <div>
                            短信订阅
                            <el-checkbox
                                v-model="checkedObj[10].status"
                                size="mini"
                                text-color="red"
                                v-on:change="handleCheck"
                            ></el-checkbox>
                        </div>
                    </el-col>
                </el-row>
                <el-row class="el-row-common background-f9f9f9">
                    <el-col class="font-weight-bold" :span="4">分红通知</el-col>
                    <el-col :span="20">
                        <div>
                            短信订阅
                            <el-checkbox
                                v-model="checkedObj[11].status"
                                size="mini"
                                text-color="red"
                                v-on:change="handleCheck"
                            ></el-checkbox>
                        </div>
                    </el-col>
                </el-row>
                <el-row class="el-row-common">
                    <el-col class="font-weight-bold" :span="4">直销实时交易</el-col>
                    <el-col :span="20">
                        <div>
                            短信订阅
                            <el-checkbox
                                v-model="checkedObj[12].status"
                                size="mini"
                                text-color="red"
                                v-on:change="handleCheck"
                            ></el-checkbox>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
        <check-mobile
            :show-mobile-comp="showMobileComp"
            v-on:dialog-close="dialogCloseFn"
        ></check-mobile>
        <change-emial
            :show-email-comp="showEmailComp"
            v-on:dialog-close="dialogCloseFn"
        ></change-emial>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import checkMobile from "./checkMobileDc.vue";
import changeEmial from "./changeEmialDc.vue";
import userApi from "@/api/user";
export default {
    name: "ServiceSubscriptDc",
    components: {
        checkMobile,
        changeEmial
    },
    mixins: [mixin],
    data() {
        return {
            showMobileComp: false,
            showEmailComp: false,
            info: {},
            checkedObj: [
                {
                    columno: 60013,
                    status: false
                },
                {
                    columno: 10003,
                    status: false
                },
                {
                    columno: 50,
                    status: false
                },
                {
                    columno: 10000,
                    status: false
                },
                {
                    columno: 60005,
                    status: false
                },
                {
                    columno: 60012,
                    status: false
                },
                {
                    columno: 60004,
                    status: false
                },
                {
                    columno: 131,
                    status: false
                },
                {
                    columno: 132,
                    status: false
                },
                {
                    columno: 133,
                    status: false
                },
                {
                    columno: 330,
                    status: false
                },
                {
                    columno: 430,
                    status: false
                },
                {
                    columno: 81005,
                    status: false
                }
            ],
            timer: null
        };
    },
    created() {
        this.info = this.$cache.getUser();
        this.qryCustomizedServer();
    },
    methods: {
        async qryCustomizedServer() {
            const checkeInfos = await userApi.qryCustomizedServer({
                qrytype: "a"
            });
            checkeInfos.data.forEach((item) => {
                this.checkedObj.forEach((checkItem) => {
                    if (item.columno == checkItem.columno) {
                        if (item.columno == "81005") {
                            checkItem.status = item.status == "0";
                        } else {
                            checkItem.status = item.status == "1";
                        }
                    }
                });
            });
        },
        modifyMobile() {
            this.showMobileComp = true;
        },
        modifyEmail() {
            this.showEmailComp = true;
        },
        dialogCloseFn(value) {
            this.showMobileComp = value;
            this.showEmailComp = value;
            this.info = this.$cache.getUser();
        },
        handleCheck() {
            if (this.timer) clearTimeout(this.timer);
            this.timer = setTimeout(async () => {
                let columnList = JSON.stringify(this.checkedObj);
                columnList = JSON.parse(columnList);
                columnList.forEach((item) => {
                    if (item.columno == "81005") {
                        item.status = item.status ? "0" : "1";
                    } else {
                        item.status = item.status ? "1" : "0";
                    }
                });
                const res = await userApi.modifyCustomizedServer({
                    columnList: columnList
                });
                if (res.code == "0") {
                    this.$message({
                        type: "success",
                        message: "修改服务定制信息成功！"
                    });
                }
                this.qryCustomizedServer();
            }, 1000);
        }
    }
};
</script>
<style lang="scss" scoped>
.bizcomp-service-subscript {
    .service-subscript-head {
        display: flex;
        align-items: center;
        .service-subscript-head-bar {
            width: 3.71px;
            height: 16px;
            background: #e60012;
        }
        .service-subscript-head-text {
            margin-left: 6.3px;
            font-size: 18px;
            font-weight: 500;
            color: #333333;
        }
    }
    .service-subscript-phone-email {
        display: flex;
        margin-top: 20px;
        .service-subscript-email-contain {
            margin-left: 20px;
        }
        .service-subscript-phone-contain {
            width: 234px;
            border-radius: 6px;
            background: #f9f9f9;
            display: flex;
            justify-content: space-between;
            padding: 18px 16px;
            .service-subscript-phone {
                .service-subscript-phone-title {
                    font-size: 16px;
                    font-weight: 500;
                    color: #333333;
                }
                .service-subscript-phone-text {
                    margin-top: 12px;
                    font-size: 18px;
                    font-weight: bold;
                    color: #333333;
                }
            }
        }
    }
    .service-subscript-content {
        background: #ffffff;
        box-sizing: border-box;
        border: 1px solid #f1f1f1;
        margin-top: 20px;
        .el-row-common {
            height: 50px;
            line-height: 50px;
            padding: 0 16px;
        }
        .sms-email-subscription {
            display: flex;
            align-items: center;
            .email-subscription {
                margin-left: 52px;
            }
        }
    }

    .font-weight-bold {
        font-weight: bold;
    }
    .background-f9f9f9 {
        background: #f9f9f9;
    }
    :deep(.el-checkbox__input) {
        .el-checkbox__inner {
            border-color: #dcdfe6 !important;
            background-color: #ffffff !important;
        }
        .el-checkbox__inner:after {
            border-color: #dcdfe6 !important;
            -webkit-transform: rotate(45deg) scaleY(1);
            transform: rotate(45deg) scaleY(1);
        }
    }
    .el-checkbox .el-checkbox__inner:not(.is-checked) {
        display: block !important; /* 确保不被隐藏 */
    }
    :deep(.is-checked) {
        .el-checkbox__inner {
            border-color: #e60012 !important;
            background-color: #e60012 !important;
        }
        .el-checkbox__inner:after {
            border-color: #f9f9f9 !important;
        }
    }
    .cursor-pointer {
        cursor: pointer;
    }
    .margin-l-40 {
        margin-top: 40px;
    }
}
</style>
